import styled from "styled-components";
import { Link } from "react-router-dom";

export const Content = styled("div")`
	padding: 22px 20px;
`;

export const Title = styled("h1")`
	font-size: 16px;
	margin: 0px;
`;

export const Subtitle = styled("h3")`
	font-size: 14px;
	font-weight: normal;
	margin: 0px;
`;

export const Module = styled("div")`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

export const NavUnits = styled(Link).attrs<{ disabled?: boolean }>((props) => ({
	as: props.disabled ? "div" : Link, // Si está deshabilitado, lo convierte en <div> para evitar navegación.
}))<{ disabled?: boolean }>`
	background-color: ${({ disabled }) => (disabled ? "#00000040" : "white")};
	padding: 10px;
	display: block;
	border-radius: 5px;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
	text-decoration: none;
	color: inherit;
	pointer-events: ${({ disabled }) => (disabled ? "not-allowed" : "auto")};
	cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

export const NavUnitsBtn = styled("button")`
	border: 0px;
	margin: 0px;
	pointer-events: ${({ disabled }) => (disabled ? "not-allowed" : "auto")};
	cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
	width: 100%;
	text-align: left;
	background-color: ${({ disabled }) => (disabled ? "#00000040" : "white")};
	padding: 10px;
	display: block;
	border-radius: 5px;
	box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
	text-decoration: none;
	color: inherit;
`;

export const TimerWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	gap: 5px;
	margin-bottom: 0px;
	margin-top: 5px;
`;

export const TimerText = styled.div`
	font-size: 14px;
	color: #e20014;
`;
